// generated/search-api/models/inputAccessRequestPreferredLanguage.ts
var InputAccessRequestPreferredLanguage = {
  DE: "DE",
  EN: "EN",
  ES: "ES",
  FR: "FR",
  DA: "DA",
  EL: "EL",
  PT: "PT",
  IT: "IT",
  CS: "CS",
  CA: "CA",
  NL: "NL",
  HU: "HU",
  HR: "HR"
};

// generated/search-api/models/inputContactPreferredLanguage.ts
var InputContactPreferredLanguage = {
  DE: "DE",
  EN: "EN",
  ES: "ES",
  FR: "FR",
  DA: "DA",
  EL: "EL",
  PT: "PT",
  IT: "IT",
  CS: "CS",
  CA: "CA",
  NL: "NL",
  HU: "HU",
  HR: "HR",
  PL: "PL"
};

// generated/search-bff/models/addressTypeDto.ts
var AddressTypeDto = {
  natural_feature: "natural_feature",
  room: "room",
  floor: "floor",
  street_number: "street_number",
  supermarket: "supermarket",
  gas_station: "gas_station",
  stadium: "stadium",
  bakery: "bakery",
  place_of_worship: "place_of_worship",
  grocery_or_supermarket: "grocery_or_supermarket",
  establishment: "establishment",
  colloquial_area: "colloquial_area",
  premise: "premise",
  subpremise: "subpremise",
  lodging: "lodging",
  finance: "finance",
  health: "health",
  meal_delivery: "meal_delivery",
  plus_code: "plus_code",
  post_box: "post_box",
  point_of_interest: "point_of_interest",
  bus_station: "bus_station",
  doctor: "doctor",
  furniture_store: "furniture_store",
  train_station: "train_station",
  subway_station: "subway_station",
  transit_station: "transit_station",
  light_rail_station: "light_rail_station",
  school: "school",
  lawyer: "lawyer",
  primary_school: "primary_school",
  secondary_school: "secondary_school",
  store: "store",
  shopping_mall: "shopping_mall",
  art_gallery: "art_gallery",
  street_address: "street_address",
  park: "park",
  parking: "parking",
  restaurant: "restaurant",
  bar: "bar",
  meal_takeaway: "meal_takeaway",
  clothing_store: "clothing_store",
  local_government_office: "local_government_office",
  moving_company: "moving_company",
  storage: "storage",
  car_repair: "car_repair",
  intersection: "intersection",
  route: "route",
  ward: "ward",
  tourist_attraction: "tourist_attraction",
  drugstore: "drugstore",
  general_contractor: "general_contractor",
  food: "food",
  real_estate_agency: "real_estate_agency",
  car_rental: "car_rental",
  travel_agency: "travel_agency",
  electronics_store: "electronics_store",
  home_goods_store: "home_goods_store",
  insurance_agency: "insurance_agency",
  painter: "painter",
  airport: "airport",
  town_square: "town_square",
  cafe: "cafe",
  museum: "museum",
  campground: "campground",
  rv_park: "rv_park",
  archipelago: "archipelago",
  accounting: "accounting",
  amusement_park: "amusement_park",
  aquarium: "aquarium",
  atm: "atm",
  beach: "beach",
  bank: "bank",
  beauty_salon: "beauty_salon",
  bicycle_store: "bicycle_store",
  book_store: "book_store",
  bowling_alley: "bowling_alley",
  car_dealer: "car_dealer",
  car_wash: "car_wash",
  casino: "casino",
  cemetery: "cemetery",
  church: "church",
  city_hall: "city_hall",
  convenience_store: "convenience_store",
  courthouse: "courthouse",
  dentist: "dentist",
  department_store: "department_store",
  electrician: "electrician",
  embassy: "embassy",
  fire_station: "fire_station",
  florist: "florist",
  funeral_home: "funeral_home",
  gym: "gym",
  hair_care: "hair_care",
  hardware_store: "hardware_store",
  hindu_temple: "hindu_temple",
  hospital: "hospital",
  jewelry_store: "jewelry_store",
  laundry: "laundry",
  library: "library",
  liquor_store: "liquor_store",
  locksmith: "locksmith",
  mosque: "mosque",
  movie_rental: "movie_rental",
  movie_theater: "movie_theater",
  night_club: "night_club",
  pet_store: "pet_store",
  pharmacy: "pharmacy",
  physiotherapist: "physiotherapist",
  plumber: "plumber",
  police: "police",
  post_office: "post_office",
  roofing_contractor: "roofing_contractor",
  shoe_store: "shoe_store",
  spa: "spa",
  synagogue: "synagogue",
  taxi_stand: "taxi_stand",
  university: "university",
  veterinary_care: "veterinary_care",
  school_district: "school_district",
  zoo: "zoo",
  island: "island",
  woods: "woods",
  river: "river",
  lake: "lake",
  mountain_peak: "mountain_peak",
  landmark: "landmark",
  address: "address",
  cities: "cities",
  neighborhood: "neighborhood",
  sublocality: "sublocality",
  sublocality_level_5: "sublocality_level_5",
  sublocality_level_4: "sublocality_level_4",
  sublocality_level_3: "sublocality_level_3",
  sublocality_level_2: "sublocality_level_2",
  sublocality_level_1: "sublocality_level_1",
  locality: "locality",
  postal_town: "postal_town",
  postal_code_prefix: "postal_code_prefix",
  postal_code: "postal_code",
  postal_code_suffix: "postal_code_suffix",
  administrative_area_level_7: "administrative_area_level_7",
  administrative_area_level_6: "administrative_area_level_6",
  administrative_area_level_5: "administrative_area_level_5",
  administrative_area_level_4: "administrative_area_level_4",
  administrative_area_level_3: "administrative_area_level_3",
  administrative_area_level_2: "administrative_area_level_2",
  administrative_area_level_1: "administrative_area_level_1",
  country: "country",
  continent: "continent",
  political: "political",
  unknown: "unknown",
  geocode: "geocode"
};

// generated/search-bff/models/areaUnit.ts
var AreaUnit = {
  ac: "ac",
  ha: "ha",
  sqft: "sqft",
  sqmt: "sqmt"
};

// generated/search-bff/models/belgiumFloodProneArea.ts
var BelgiumFloodProneArea = {
  EFFECTIVELY_FLOOD_PRONE_AREA: "EFFECTIVELY_FLOOD_PRONE_AREA",
  NOT_FLOOD_PRONE: "NOT_FLOOD_PRONE",
  POSSIBLY_FLOOD_PRONE_AREA: "POSSIBLY_FLOOD_PRONE_AREA"
};

// generated/search-bff/models/belgiumFloodRiskScore.ts
var BelgiumFloodRiskScore = {
  A: "A",
  B: "B",
  C: "C",
  D: "D"
};

// generated/search-bff/models/belgiumSummonsAndRecoveryOrder.ts
var BelgiumSummonsAndRecoveryOrder = {
  BO: "BO",
  DV: "DV",
  GDV: "GDV",
  GMO: "GMO",
  HO: "HO",
  LOD: "LOD",
  MS: "MS"
};

// generated/search-bff/models/belgiumUrbanPlanningDestination.ts
var BelgiumUrbanPlanningDestination = {
  AG: "AG",
  BG: "BG",
  GDR: "GDR",
  GVR: "GVR",
  IAB: "IAB",
  IGB: "IGB",
  LWAG: "LWAG",
  NG: "NG",
  NR: "NR",
  PG: "PG",
  WCHE: "WCHE",
  WG: "WG",
  WGLK: "WGLK",
  WP: "WP",
  WUG: "WUG"
};

// generated/search-bff/models/buildingRestriction.ts
var BuildingRestriction = {
  NONE: "NONE",
  SINGLE_MONUMENT_BUILDING: "SINGLE_MONUMENT_BUILDING",
  ENSEMBLE_MONUMENT: "ENSEMBLE_MONUMENT",
  FRONT_OF_BUILDING_MONUMENT: "FRONT_OF_BUILDING_MONUMENT"
};

// generated/search-bff/models/businessArea.ts
var BusinessArea = {
  residential: "residential",
  commercial: "commercial"
};

// generated/search-bff/models/contactPreference.ts
var ContactPreference = {
  SHOP: "SHOP",
  SUB_SHOP: "SUB_SHOP"
};

// generated/search-bff/models/coordinateSystemAxisDirection.ts
var CoordinateSystemAxisDirection = {
  NORTH: "NORTH",
  EAST: "EAST",
  SOUTH: "SOUTH",
  WEST: "WEST",
  UP: "UP",
  DOWN: "DOWN",
  OTHER: "OTHER",
  UNKNOWN: "UNKNOWN",
  GeocentricX: "GeocentricX",
  GeocentricY: "GeocentricY",
  GeocentricZ: "GeocentricZ"
};

// generated/search-bff/models/countryCode.ts
var CountryCode = {
  AD: "AD",
  AE: "AE",
  AT: "AT",
  AW: "AW",
  BE: "BE",
  BS: "BS",
  BZ: "BZ",
  CA: "CA",
  CH: "CH",
  CL: "CL",
  CO: "CO",
  CR: "CR",
  CZ: "CZ",
  DE: "DE",
  DK: "DK",
  ES: "ES",
  FR: "FR",
  GR: "GR",
  HR: "HR",
  HU: "HU",
  IE: "IE",
  IT: "IT",
  KY: "KY",
  LI: "LI",
  LU: "LU",
  MF: "MF",
  MG: "MG",
  MU: "MU",
  MX: "MX",
  NL: "NL",
  PA: "PA",
  PL: "PL",
  PT: "PT",
  SM: "SM",
  TC: "TC",
  US: "US",
  UY: "UY",
  VG: "VG",
  ZA: "ZA"
};

// generated/search-bff/models/currency.ts
var Currency = {
  EUR: "EUR",
  AED: "AED",
  BSD: "BSD",
  BZD: "BZD",
  CAD: "CAD",
  CHF: "CHF",
  CLF: "CLF",
  CLP: "CLP",
  CNY: "CNY",
  COP: "COP",
  CRC: "CRC",
  CZK: "CZK",
  DKK: "DKK",
  GBP: "GBP",
  HKD: "HKD",
  HUF: "HUF",
  KYD: "KYD",
  MUR: "MUR",
  MXN: "MXN",
  OMR: "OMR",
  PAB: "PAB",
  PLN: "PLN",
  QAR: "QAR",
  SEK: "SEK",
  TRY: "TRY",
  USD: "USD",
  ZAR: "ZAR"
};

// generated/search-bff/models/energyClass.ts
var EnergyClass = {
  UNKNOWN: "UNKNOWN",
  NOT_APPLICABLE: "NOT_APPLICABLE",
  IN_PROGRESS: "IN_PROGRESS",
  I: "I",
  H: "H",
  G: "G",
  F: "F",
  E: "E",
  D: "D",
  C: "C",
  B: "B",
  A: "A",
  A4: "A4",
  A3: "A3",
  A2: "A2",
  A1: "A1",
  A0: "A0",
  A20: "A20",
  A15: "A15",
  A10: "A10",
  B1: "B1",
  B2: "B2",
  B3: "B3",
  C1: "C1",
  C2: "C2",
  C3: "C3",
  D1: "D1",
  D2: "D2",
  E1: "E1",
  E2: "E2",
  B_PLUS: "B_PLUS",
  B_MINUS: "B_MINUS",
  A_2010: "A_2010",
  A_PLUS: "A_PLUS",
  A_2015: "A_2015",
  A_2_PLUS: "A_2_PLUS",
  A_2020: "A_2020",
  A_3_PLUS: "A_3_PLUS",
  A_4_PLUS: "A_4_PLUS"
};

// generated/search-bff/models/fuzzyAlgorithm.ts
var FuzzyAlgorithm = {
  V1: "V1",
  V2: "V2",
  V3: "V3",
  V4: "V4"
};

// generated/search-bff/models/geometryType.ts
var GeometryType = {
  POINT: "POINT",
  CURVE: "CURVE",
  SURFACE: "SURFACE",
  GEOMETRYCOLLECTION: "GEOMETRYCOLLECTION",
  LINESTRING: "LINESTRING",
  LINEARRING: "LINEARRING",
  POLYGON: "POLYGON",
  MULTIPOINT: "MULTIPOINT",
  MULTIPOLYGON: "MULTIPOLYGON",
  MULTILINESTRING: "MULTILINESTRING"
};

// generated/search-bff/models/getListingResponseStatus.ts
var GetListingResponseStatus = {
  OK: "OK",
  RESTRICTED: "RESTRICTED",
  USER_ACCOUNT_EXCLUSIVE: "USER_ACCOUNT_EXCLUSIVE",
  INVALID_SECRET_ACCESS_ID: "INVALID_SECRET_ACCESS_ID",
  INVALID_PASSWORD: "INVALID_PASSWORD"
};

// generated/search-bff/models/heatingType.ts
var HeatingType = {
  heatingTypeunderFloor: "heatingType.underFloor",
  heatingTyperadiator: "heatingType.radiator"
};

// generated/search-bff/models/imageAiType.ts
var ImageAiType = {
  UNKNOWN: "UNKNOWN",
  NONE: "NONE",
  MODIFIED: "MODIFIED",
  GENERATED: "GENERATED"
};

// generated/search-bff/models/imageDisturber.ts
var ImageDisturber = {
  UNLOCKED: "UNLOCKED",
  SOLD: "SOLD",
  RENTED_OUT: "RENTED_OUT",
  RESERVED: "RESERVED",
  PRICE_UPDATED: "PRICE_UPDATED",
  NEW: "NEW",
  EXCLUSIVE: "EXCLUSIVE"
};

// generated/search-bff/models/imageType.ts
var ImageType = {
  image: "image",
  floor_plan: "floor_plan",
  map: "map"
};

// generated/search-bff/models/kind.ts
var Kind = {
  PARAGRAPH: "PARAGRAPH",
  LIST: "LIST"
};

// generated/search-bff/models/language.ts
var Language = {
  ca: "ca",
  cs: "cs",
  da: "da",
  nl: "nl",
  en: "en",
  fr: "fr",
  de: "de",
  el: "el",
  hu: "hu",
  it: "it",
  pl: "pl",
  pt: "pt",
  es: "es",
  hr: "hr"
};

// generated/search-bff/models/lifestyleCategory.ts
var LifestyleCategory = {
  EQUESTRIAN: "EQUESTRIAN",
  GOLF: "GOLF",
  MOUNTAIN: "MOUNTAIN",
  RANCH: "RANCH",
  SKI: "SKI",
  WATERFRONT: "WATERFRONT",
  VINEYARDS_WINERIES: "VINEYARDS_WINERIES",
  CASTLE_MANORHOUSES: "CASTLE_MANORHOUSES",
  PENTHOUSE: "PENTHOUSE"
};

// generated/search-bff/models/listingSortOption.ts
var ListingSortOption = {
  SALES_PRICE_DESC: "SALES_PRICE_DESC",
  SALES_PRICE_ASC: "SALES_PRICE_ASC",
  DISPLAY_ID_FROM_FILTER: "DISPLAY_ID_FROM_FILTER",
  LISTING_ID_FROM_FILTER: "LISTING_ID_FROM_FILTER",
  RENT_DESC: "RENT_DESC",
  RENT_ASC: "RENT_ASC",
  CREATED_AT_DESC: "CREATED_AT_DESC",
  CREATED_AT_ASC: "CREATED_AT_ASC",
  LIVING_SURFACE_DESC: "LIVING_SURFACE_DESC",
  LIVING_SURFACE_ASC: "LIVING_SURFACE_ASC",
  TOTAL_SURFACE_ASC: "TOTAL_SURFACE_ASC",
  TOTAL_SURFACE_DESC: "TOTAL_SURFACE_DESC",
  PUBLISHED_AT_DESC: "PUBLISHED_AT_DESC",
  PUBLISHED_AT_ASC: "PUBLISHED_AT_ASC",
  PROPERTY_KIND_DESC: "PROPERTY_KIND_DESC",
  PROPERTY_KIND_ASC: "PROPERTY_KIND_ASC",
  BUSINESS_AREA_DESC: "BUSINESS_AREA_DESC",
  BUSINESS_AREA_ASC: "BUSINESS_AREA_ASC",
  PROPERTY_MARKETING_TYPE_DESC: "PROPERTY_MARKETING_TYPE_DESC",
  PROPERTY_MARKETING_TYPE_ASC: "PROPERTY_MARKETING_TYPE_ASC",
  PREFERENCES: "PREFERENCES"
};

// generated/search-bff/models/listingSourceFormat.ts
var ListingSourceFormat = {
  OpenImmo: "OpenImmo",
  RealEstate: "RealEstate",
  PortalExport: "PortalExport"
};

// generated/search-bff/models/listingStatus.ts
var ListingStatus = {
  ACTIVE: "ACTIVE",
  OFFERSHOW: "OFFERSHOW",
  OFFERNOSHOW: "OFFERNOSHOW",
  SOLDBYEV: "SOLDBYEV",
  LETBYEV: "LETBYEV",
  CLOSEDBYEV: "CLOSEDBYEV"
};

// generated/search-bff/models/listingStatusNormalized.ts
var ListingStatusNormalized = {
  ACTIVE: "ACTIVE",
  SOLD: "SOLD"
};

// generated/search-bff/models/listStyle.ts
var ListStyle = {
  BULLET: "BULLET",
  DIAMOND: "DIAMOND"
};

// generated/search-bff/models/listType.ts
var ListType = {
  ORDERED: "ORDERED",
  UNORDERED: "UNORDERED"
};

// generated/search-bff/models/marketCountryCode.ts
var MarketCountryCode = {
  AD: "AD",
  AE: "AE",
  AT: "AT",
  BE: "BE",
  BS: "BS",
  BZ: "BZ",
  CA: "CA",
  CH: "CH",
  CL: "CL",
  CO: "CO",
  CR: "CR",
  CZ: "CZ",
  DE: "DE",
  DK: "DK",
  ES: "ES",
  FR: "FR",
  GR: "GR",
  HR: "HR",
  HU: "HU",
  IE: "IE",
  IT: "IT",
  KY: "KY",
  LI: "LI",
  LU: "LU",
  MF: "MF",
  MG: "MG",
  MU: "MU",
  MX: "MX",
  NL: "NL",
  PA: "PA",
  PL: "PL",
  PT: "PT",
  TC: "TC",
  US: "US",
  UY: "UY",
  VG: "VG",
  ZA: "ZA",
  "private-office": "private-office"
};

// generated/search-bff/models/measurementSystem.ts
var MeasurementSystem = {
  metric: "metric",
  imperial: "imperial"
};

// generated/search-bff/models/placeType.ts
var PlaceType = {
  accounting: "accounting",
  airport: "airport",
  amusement_park: "amusement_park",
  aquarium: "aquarium",
  art_gallery: "art_gallery",
  atm: "atm",
  bakery: "bakery",
  bank: "bank",
  bar: "bar",
  beauty_salon: "beauty_salon",
  bicycle_store: "bicycle_store",
  book_store: "book_store",
  bowling_alley: "bowling_alley",
  bus_station: "bus_station",
  cafe: "cafe",
  campground: "campground",
  car_dealer: "car_dealer",
  car_rental: "car_rental",
  car_repair: "car_repair",
  car_wash: "car_wash",
  casino: "casino",
  cemetery: "cemetery",
  church: "church",
  city_hall: "city_hall",
  clothing_store: "clothing_store",
  convenience_store: "convenience_store",
  courthouse: "courthouse",
  dentist: "dentist",
  department_store: "department_store",
  doctor: "doctor",
  drugstore: "drugstore",
  electrician: "electrician",
  electronics_store: "electronics_store",
  embassy: "embassy",
  fire_station: "fire_station",
  florist: "florist",
  funeral_home: "funeral_home",
  furniture_store: "furniture_store",
  gas_station: "gas_station",
  gym: "gym",
  hair_care: "hair_care",
  hardware_store: "hardware_store",
  hindu_temple: "hindu_temple",
  home_goods_store: "home_goods_store",
  hospital: "hospital",
  insurance_agency: "insurance_agency",
  jewelry_store: "jewelry_store",
  laundry: "laundry",
  lawyer: "lawyer",
  library: "library",
  light_rail_station: "light_rail_station",
  liquor_store: "liquor_store",
  local_government_office: "local_government_office",
  locksmith: "locksmith",
  lodging: "lodging",
  meal_delivery: "meal_delivery",
  meal_takeaway: "meal_takeaway",
  mosque: "mosque",
  movie_rental: "movie_rental",
  movie_theater: "movie_theater",
  moving_company: "moving_company",
  museum: "museum",
  night_club: "night_club",
  painter: "painter",
  park: "park",
  parking: "parking",
  pet_store: "pet_store",
  pharmacy: "pharmacy",
  physiotherapist: "physiotherapist",
  plumber: "plumber",
  police: "police",
  post_office: "post_office",
  primary_school: "primary_school",
  real_estate_agency: "real_estate_agency",
  restaurant: "restaurant",
  roofing_contractor: "roofing_contractor",
  rv_park: "rv_park",
  school: "school",
  secondary_school: "secondary_school",
  shoe_store: "shoe_store",
  shopping_mall: "shopping_mall",
  spa: "spa",
  stadium: "stadium",
  storage: "storage",
  store: "store",
  subway_station: "subway_station",
  supermarket: "supermarket",
  synagogue: "synagogue",
  taxi_stand: "taxi_stand",
  tourist_attraction: "tourist_attraction",
  train_station: "train_station",
  transit_station: "transit_station",
  travel_agency: "travel_agency",
  university: "university",
  veterinary_care: "veterinary_care",
  zoo: "zoo",
  administrative_area_level_1: "administrative_area_level_1",
  administrative_area_level_2: "administrative_area_level_2",
  administrative_area_level_3: "administrative_area_level_3",
  administrative_area_level_4: "administrative_area_level_4",
  administrative_area_level_5: "administrative_area_level_5",
  administrative_area_level_6: "administrative_area_level_6",
  administrative_area_level_7: "administrative_area_level_7",
  archipelago: "archipelago",
  colloquial_area: "colloquial_area",
  continent: "continent",
  finance: "finance",
  floor: "floor",
  food: "food",
  general_contractor: "general_contractor",
  health: "health",
  intersection: "intersection",
  landmark: "landmark",
  natural_feature: "natural_feature",
  place_of_worship: "place_of_worship",
  plus_code: "plus_code",
  point_of_interest: "point_of_interest",
  political: "political",
  post_box: "post_box",
  postal_code_prefix: "postal_code_prefix",
  postal_code_suffix: "postal_code_suffix",
  postal_code: "postal_code",
  postal_town: "postal_town",
  premise: "premise",
  room: "room",
  route: "route",
  street_address: "street_address",
  street_number: "street_number",
  sublocality_level_1: "sublocality_level_1",
  sublocality_level_2: "sublocality_level_2",
  sublocality_level_3: "sublocality_level_3",
  sublocality_level_4: "sublocality_level_4",
  sublocality_level_5: "sublocality_level_5",
  subpremise: "subpremise",
  town_square: "town_square",
  country: "country",
  locality: "locality",
  sublocality: "sublocality",
  neighborhood: "neighborhood",
  geocode: "geocode",
  establishment: "establishment",
  address: "address",
  cities: "cities"
};

// generated/search-bff/models/polygonSource.ts
var PolygonSource = {
  google: "google",
  osm: "osm",
  fotocasa: "fotocasa",
  custom: "custom"
};

// generated/search-bff/models/privacyLevel.ts
var PrivacyLevel = {
  PUBLIC: "PUBLIC",
  RESTRICTED: "RESTRICTED",
  UNLISTED: "UNLISTED",
  PO_ONLY: "PO_ONLY"
};

// generated/search-bff/models/propertyKind.ts
var PropertyKind = {
  object: "object",
  group: "group"
};

// generated/search-bff/models/propertyMarketingType.ts
var PropertyMarketingType = {
  sale: "sale",
  rent: "rent"
};

// generated/search-bff/models/propertySubType.ts
var PropertySubType = {
  apartment_house: "apartment_house",
  bungalow: "bungalow",
  country_house: "country_house",
  castle: "castle",
  detached_house: "detached_house",
  finca: "finca",
  investment: "investment",
  semi_detached_house: "semi_detached_house",
  terraced_house: "terraced_house",
  townhouse: "townhouse",
  villa: "villa",
  attic: "attic",
  flat: "flat",
  loft: "loft",
  maisonette: "maisonette",
  penthouse: "penthouse",
  special_property: "special_property",
  land: "land",
  site: "site",
  parking: "parking",
  developments: "developments",
  projects: "projects",
  other: "other",
  new_developments: "new_developments",
  lager_mit_freiflaeche: "lager_mit_freiflaeche",
  industriehalle: "industriehalle",
  hochregallager: "hochregallager",
  speditionslager: "speditionslager",
  lager: "lager",
  "": ""
};

// generated/search-bff/models/propertyType.ts
var PropertyType = {
  apartment: "apartment",
  agriculture_and_forestry: "agriculture_and_forestry",
  commercial_space: "commercial_space",
  group: "group",
  gastronomy: "gastronomy",
  house: "house",
  hotel: "hotel",
  industry: "industry",
  investment: "investment",
  land: "land",
  motor: "motor",
  office: "office",
  other: "other",
  retail_services: "retail services",
  sail: "sail",
  store: "store",
  "": ""
};

// generated/search-bff/models/searchAlertState.ts
var SearchAlertState = {
  CREATED: "CREATED",
  ACTIVE: "ACTIVE"
};

// generated/search-bff/models/searchAlertVersion.ts
var SearchAlertVersion = {
  V3: "V3",
  V4: "V4"
};

// generated/search-bff/models/sortingOrder.ts
var SortingOrder = {
  ASC: "ASC",
  DESC: "DESC"
};

// generated/search-bff/models/sortingType.ts
var SortingType = {
  CREATED_AT: "CREATED_AT",
  PUBLISHED_AT: "PUBLISHED_AT",
  SALES_PRICE: "SALES_PRICE",
  LIVING_SURFACE: "LIVING_SURFACE",
  TOTAL_SURFACE: "TOTAL_SURFACE",
  RENT: "RENT"
};

// generated/search-bff/models/vtourProvider.ts
var VtourProvider = {
  UNKNOWN: "UNKNOWN",
  FLOORFY: "FLOORFY",
  MATTERPORT: "MATTERPORT",
  OGULO: "OGULO",
  IGUIDE: "IGUIDE",
  PROPERTY_PANORAMA: "PROPERTY_PANORAMA",
  GIRAFFE360: "GIRAFFE360"
};

// generated/ai-chat-bot/models/chatbotMessageType.ts
var ChatbotMessageType = {
  USER: "USER",
  CHATBOT: "CHATBOT"
};

export {
  InputAccessRequestPreferredLanguage,
  InputContactPreferredLanguage,
  AddressTypeDto,
  AreaUnit,
  BelgiumFloodProneArea,
  BelgiumFloodRiskScore,
  BelgiumSummonsAndRecoveryOrder,
  BelgiumUrbanPlanningDestination,
  BuildingRestriction,
  BusinessArea,
  ContactPreference,
  CoordinateSystemAxisDirection,
  CountryCode,
  Currency,
  EnergyClass,
  FuzzyAlgorithm,
  GeometryType,
  GetListingResponseStatus,
  HeatingType,
  ImageAiType,
  ImageDisturber,
  ImageType,
  Kind,
  Language,
  LifestyleCategory,
  ListingSortOption,
  ListingSourceFormat,
  ListingStatus,
  ListingStatusNormalized,
  ListStyle,
  ListType,
  MarketCountryCode,
  MeasurementSystem,
  PlaceType,
  PolygonSource,
  PrivacyLevel,
  PropertyKind,
  PropertyMarketingType,
  PropertySubType,
  PropertyType,
  SearchAlertState,
  SearchAlertVersion,
  SortingOrder,
  SortingType,
  VtourProvider,
  ChatbotMessageType
};
